import React, { useState, useEffect } from "react";
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Col, Row } from "reactstrap";
import { Dropdown } from 'primereact/dropdown';
import axios from 'axios';

const LinkContactJob1 = ({ setsubtypeget, setcontactvalu, setNewErrors, newErrors, selectedCustomers }) => {
  const [typeInterview, setTypeInterview] = useState([]);
  const [typeInterviewcontacts, setTypeInterviewcontacts] = useState([]);
  const [subtypegets, setSubtypegets] = useState(null);
  const [prioritycontact, setPrioritycontact] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [dialogVisible, setDialogVisible] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 1,
  });
  const [totalRecords, setTotalRecords] = useState(0);

  // Handle job selection from Dropdown
  const handleJobChange = (e) => {
    setSubtypegets(e.value);
    setsubtypeget(e.value ? [e.value.id] : []);
  };

  // Fetch jobs from API
  const getJobs = async (page, size) => {
    try {
      const response = await axios.get(`/api/v1/jobs/?page=${page}&size=${size}`);
      const transformedData = response.data.results.map((job) => ({
        name: job.job_title,
        id: job.job_id,
      }));
      setTypeInterview(transformedData);
      setfilteredJobslink(transformedData);
      setTotalRecords(response.data.count);
    } catch (error) {
      console.error('Error fetching jobs:', error);
    }
  };

  // Fetch contacts from API
  const getAllActiveContacts = async (page, size) => {
    try {
      const response = await axios.get(`/api/v1/contacts/?page=${page}&size=${size}&status=Active`);
      const transformedData = response.data.results.map((contact) => ({
        name: contact.first_name,
        id: contact.id,
      }));
      setTypeInterviewcontacts(transformedData);
      setTotalRecords(response.data.count);
    } catch (error) {
      console.error('Error fetching contacts:', error);
    }
  };

  // Handle pagination change
  const onPageChange = (event) => {
    setLazyParams({
      ...lazyParams,
      first: event.first,
      rows: event.rows,
      page: event.page + 1,
    });
    getAllActiveContacts(event.page + 1, event.rows);
  };

  // Fetch data on component mount
  useEffect(() => {
    console.log("job idddd", subtypegets)
    // getJobs(lazyParams.page, lazyParams.rows);
    getAllActiveContacts(lazyParams.page, lazyParams.rows);
  }, []);

  const handleIconClick = () => {
    setDialogVisible(true);
  };

  const closeDialog = () => {
    setDialogVisible(false);
  };

  const handleSave = () => {
    const selectedNames = selectedContacts.map((contact) => contact.name).join(', ');
    const selectedIds = selectedContacts.map((contact) => contact.id);
    setPrioritycontact(selectedNames);
    setcontactvalu(selectedIds);
    setDialogVisible(false);
  };

  // Set selected contacts from parent component
  useEffect(() => {
    if (selectedCustomers && selectedCustomers.length > 0) {
      const selectedContactNames = selectedCustomers.map((contact) => contact.first_name).join(', ');
      const selectedContactIds = selectedCustomers.map((contact) => contact.id);
      setPrioritycontact(selectedContactNames);
      setSelectedContacts(selectedCustomers);
    }
  }, [selectedCustomers]);

  const filteredContacts = typeInterviewcontacts.filter((contact) => {
    const name = contact.name || ''; // Fallback to empty string if name is null/undefined
    const id = contact.id != null ? contact.id.toString() : ''; // Fallback to empty string if id is null/undefined
    return (
      name.toLowerCase().includes(searchText.toLowerCase()) ||
      id.includes(searchText.toLowerCase())
    );
  });


  const [selectedJobTitles, setSelectedJobTitles] = useState([]);
  const [jobDetailsVisiblelist, setjobDetailsVisiblelist] = useState('');
  const [successAlertlink, setsuccessAlertlink] = useState(false);
  const [selectedJobListname, setselectedJobListname] = useState([])
  const [filteredJobslink, setfilteredJobslink] = useState([])
  const [lazyParamsjob1, setlazyParamsjob1] = useState({ page: 0, rows: 10 });
  const [totalRecordsjob1, setTotalRecordsjob1] = useState(0);
  const [selectedJobsData, setSelectedJobsData] = useState([]);

  const handleIconClickjob = () => {
    setjobDetailsVisiblelist(true);
    setselectedJobListname(selectedJobsData);
  };
  const [searchText1, setSearchText1] = useState('');
  const filterDatalinkjOB = (data) =>
    data.filter(

      (item) =>
        item.job_title?.toLowerCase().includes(searchText1.toLowerCase()) ||
        item.job_number?.toLowerCase().includes(searchText1.toLowerCase())

    );

  const getjobvallist = async () => {
    try {
      const response = await axios.get(`/api/v1/jobs/?page=${lazyParamsjob1.page + 1}&size=${lazyParamsjob1.rows}?fields=job_id,job_title,&status=Approved / open`, {});
      if (response.data) {
        setfilteredJobslink(response.data.results);
        setTotalRecordsjob1(response.data.count);
        console.log(response.data.count)
      }

    } catch (error) {
    }
  };

  useEffect(() => {
    getjobvallist();
  }, [lazyParamsjob1]);

  const onPageChangejob1 = (event) => {
    setlazyParamsjob1({ page: event.page, rows: event.rows });
  };
  const handleRefreshlinkjobs = () => {
    setselectedJobListname([]);
    setSelectedJobTitles([])
    setSearchText1("")
  };

  const handleSaveJobs = () => {
    const titles = selectedJobsData.map((job) => job.job_title);
    const selectedIds = selectedJobsData.map((job) => job.job_id);
    console.log(selectedIds)
    setSelectedJobTitles(titles.join(", "));
    setjobDetailsVisiblelist(false);
    setsubtypeget(selectedIds)
  };

  return (
    <>
      <Row className="mb-4">

        <Col xl={6}>
          <div className="field">
            <label htmlFor="job" className="block mb-0">
              Jobs
            </label>
            <div className="d-flex align-items-center" style={{ position: 'relative' }}>
              <InputText
                value={selectedJobTitles}
                onChange={(e) => setSelectedJobTitles(e.target.value)}
                placeholder="Select Jobs"
                className="w-full"
                style={{ paddingRight: '2rem' }}
                readOnly
              />
              <i
                className="pi pi-chevron-down"
                onClick={handleIconClickjob}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer'
                }}
              ></i>
            </div>

            <Dialog
              header="Job Details"
              visible={jobDetailsVisiblelist}
              onHide={() => setjobDetailsVisiblelist(false)}
              style={{ width: '40vw' }}
              breakpoints={{ '960px': '75vw', '641px': '100vw' }}
            >
              <Row>
                <Col lg={12}>
                  <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                    <InputText
                      placeholder="Search Jobs"
                      value={searchText1}
                      onInput={(e) => setSearchText1(e.target.value)}
                      style={{ paddingRight: '2rem' }}
                    />
                    <i
                      className="pi pi-search"
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '49%',
                        transform: 'translateY(-50%)',
                      }}
                    ></i>
                  </div>
                </Col>
              </Row>

              <DataTable
                value={filterDatalinkjOB(filteredJobslink)}
                selection={selectedJobsData}
                onSelectionChange={(e) => setSelectedJobsData(e.value)}
                dataKey="job_id"
                paginator
                lazy
                first={lazyParamsjob1.page * lazyParamsjob1.rows}
                rows={lazyParamsjob1.rows}
                totalRecords={totalRecordsjob1}
                onPage={onPageChangejob1}
                // loading={loading}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                rowsPerPageOptions={[10, 20, 50, totalRecordsjob1]}
                size="small"
              >
                <Column selectionMode="multiple" style={{ width: '3em' }} />
                <Column field="job_number" header="Job ID" />
                <Column field="job_title" header="Job Title" />
              </DataTable>

              <div className="d-flex mt-3">
                <button
                  type="submit"
                  className="btn btn-primary me-2 btn-main"
                  onClick={handleSaveJobs}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-main"
                  onClick={handleRefreshlinkjobs}
                >
                  Refresh
                </button>
              </div>
            </Dialog>

          </div>
        </Col>


        {/* <Col xl={6}>
          <div className="flex flex-column">
            <label htmlFor="Priority">Job<span className="text-danger">*</span></label>
            <Dropdown
              value={subtypegets}
              onChange={handleJobChange}
              options={typeInterview}
              optionLabel="name"
              placeholder="Select a job"
              className="w-full search-option"
            />
            {newErrors.subtypeget && (
              <small className="p-error">{newErrors.subtypeget}</small>
            )}
          </div>
        </Col> */}
        <Col xl={6}>
          <div className="p-field flex flex-column">
            <label htmlFor="contact" className="block">
              Contact
            </label>
            <div className="d-flex align-items-center" style={{ position: 'relative' }}>
              <InputText
                id="contactdetails"
                value={prioritycontact}
                placeholder="Select Contacts"
                className="w-full"
                style={{ paddingRight: '2rem' }}
              />
              <i
                className="pi pi-chevron-down"
                onClick={handleIconClick}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer'
                }}
              ></i>
            </div>
            <Dialog
              header="Select Contacts"
              visible={dialogVisible}
              onHide={closeDialog}
              style={{ width: '40vw' }}
              breakpoints={{ '960px': '75vw', '641px': '100vw' }}
              className="cand-details"
            >
              <Col lg={6}>
                <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                  <InputText
                    placeholder="Search Contacts"
                    value={searchText}
                    onInput={(e) => setSearchText(e.target.value)}
                    style={{ paddingRight: '2rem' }}
                  />
                  <i
                    className="pi pi-search"
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '49%',
                      transform: 'translateY(-50%)',
                    }}
                  ></i>
                </div>
              </Col>
              <DataTable
                value={filteredContacts}
                paginator
                lazy
                first={lazyParams.first}
                rows={lazyParams.rows}
                totalRecords={totalRecords}
                onPage={onPageChange}
                selection={selectedContacts}
                onSelectionChange={(e) => setSelectedContacts(e.value)}
                dataKey="id"
                rowsPerPageOptions={[5, 10, 25]}
                size="small"
              >
                <Column selectionMode="multiple" headerStyle={{ width: '3em' }} />
                <Column field="name" header="Contact Name" />
              </DataTable>

              <div className="d-flex mt-3">
                <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSave}>
                  Save
                </button>
                <button type="button" className="btn btn-primary btn-main" onClick={closeDialog}>
                  Cancel
                </button>
              </div>
            </Dialog>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default LinkContactJob1;
